var localeFromURL = (window.location.href).split('/')[3];
var pageFromURL = (window.location.href).split('/')[4];
var mySonyURL = (window.location.href).split('/')[5];

if(typeof localeFromURL === "undefined" || localeFromURL.length <1) localeFromURL="";
if(typeof pageFromURL === "undefined" || pageFromURL.length <1) pageFromURL="home";
if(typeof mySonyURL === "undefined" || mySonyURL.length <1) mySonyURL="";

//console.log("My Sony URL " + mySonyURL);
//console.log("Page From URL " + pageFromURL);
//console.log("Locale From URL " + localeFromURL);

localeFromURL = localeFromURL.toLowerCase();
pageFromURL = pageFromURL.toLowerCase();
mySonyURL = mySonyURL.toLowerCase();

var locale = "";
var counrty = "";
var language = "";
var domain = 'https://www.sony.co.th';
switch (localeFromURL) {
    case "sg":
        locale = "en_SG";
        country = "SG";
        language = "en";
        domain = "https://test.sony.com.sg";
        break;
    case "ph":
        locale = "en_PH";
        country = "PH";
        language = "en";
        domain = 'https://www.sony.com.ph';
        break;
    case "my":
        locale = "en_MY";
        country = "MY";
        language = "en";
        domain = 'https://test.sony.com.my';
        break;
    case "en-id":
        locale = "en_ID";
        country = "ID";
        language = "en";
        domain = 'https://www.sony.co.id';
        break;
    case "id":
        locale = "id_ID";
        country = "ID";
        domain = 'https://www.sony.co.id';
        break;
    case "en-th":
        locale = "en_TH";
        country = "TH";
        language = "en";
        domain = 'https://test.sony.co.th';
        break;
    case "vn":
        locale = "vi_VN";
        country = "VN";
        language = "vi";
        domain = 'https://test.sony.com.vn/';
        break;
    case "th":
        locale = "th_TH";
        country = "TH";
        language = "th";
        domain = 'https://test.sony.co.th';
        break;
    default:
        locale = "th_TH";
        country = "TH";
        language = "th";
        domain = 'https://test.sony.co.th';
}

/*<![CDATA[*/
if (typeof window.SonyAnalytics === "undefined") {
    window.SonyAnalytics = function () {
        this.build = function () {
            var dataLayer = {};
            dataLayer.analytics = {};
            dataLayer.analytics.version = "2017";

            dataLayer.analytics.page = {};
            dataLayer.analytics.page.brand = 'AMEA_REGIONAL';
            dataLayer.analytics.page.country = country;
            dataLayer.analytics.page.language = language;
            dataLayer.analytics.page.omniture_rsid = 'sonyglobal';

            try {
                dataLayer.analytics.user = {};
                var userObject = $("#adx_user_guid").val();
                var userOtherObject = $("#sony_user_name").val();
                if (userObject != null && userObject != undefined)
                    dataLayer.analytics.user.id = userObject;
                else if (userOtherObject != null && userOtherObject != undefined)
                    dataLayer.analytics.user.id = userOtherObject;
                else
                    dataLayer.analytics.user.id = '';
            }
            catch (err) {
                dataLayer.analytics.user.id = '';
            }
            if (pageFromURL.indexOf('home') >= 0 && mySonyURL == "") {
                dataLayer.analytics.page.section = 'amea';
                dataLayer.analytics.page.name = 'amea:mysonyloyalty:home';
                dataLayer.analytics.page.template = 'mysonyloyalty:home';
                dataLayer.analytics.page.template_revision = 'mysonyloyalty:home';
            }
            else if (pageFromURL.indexOf('home') >= 0 && mySonyURL == "index") {
                dataLayer.analytics.page.section = 'amea';
                dataLayer.analytics.page.name = 'amea:mysonyloyalty:index';
                dataLayer.analytics.page.template = 'mysonyloyalty:index';
                dataLayer.analytics.page.template_revision = 'mysonyloyalty:index';
            }
            else if (pageFromURL.indexOf('MySonyLoyalty') >= 0 && mySonyURL == "oauth2") {
                dataLayer.analytics.page.section = 'amea';
                dataLayer.analytics.page.name = 'amea:mysonyloyalty:login';
                dataLayer.analytics.page.template = 'mysonyloyalty:login';
                dataLayer.analytics.page.template_revision = 'mysonyloyalty:login';
                console.log("My Sony Login");
            }
            else if (pageFromURL.indexOf('login') >= 0 && mySonyURL == "forgotpassword") {
                dataLayer.analytics.page.section = 'amea';
                dataLayer.analytics.page.name = 'amea:mysonyloyalty:forgotpassword';
                dataLayer.analytics.page.template = 'mysonyloyalty:forgotpassword';
                dataLayer.analytics.page.template_revision = 'mysonyloyalty:forgotpassword';
            }
            else if (pageFromURL.indexOf('home') >= 0 && mySonyURL == "mysonyrewards") {
                dataLayer.analytics.page.section = 'amea';
                dataLayer.analytics.page.name = 'amea:mysonyloyalty:mysonyrewards';
                dataLayer.analytics.page.template = 'mysonyloyalty:m';
                dataLayer.analytics.page.template_revision = 'mysonyloyalty:mysoysonyrewardsnyrewards';
            }
            else if (pageFromURL.indexOf('home') >= 0 && mySonyURL == "earn") {
                dataLayer.analytics.page.section = 'amea';
                dataLayer.analytics.page.name = 'amea:mysonyloyalty:earn';
                dataLayer.analytics.page.template = 'mysonyloyalty:earn';
                dataLayer.analytics.page.template_revision = 'mysonyloyalty:earn';
            }
            else if (pageFromURL.indexOf('home') >= 0 && mySonyURL == "redeem") {
                dataLayer.analytics.page.section = 'amea';
                dataLayer.analytics.page.name = 'amea:mysonyloyalty:redeem';
                dataLayer.analytics.page.template = 'mysonyloyalty:redeem';
                dataLayer.analytics.page.template_revision = 'mysonyloyalty:redeem';
            }
            else if (pageFromURL.indexOf('home') >= 0 && mySonyURL == "registerproduct") {
                dataLayer.analytics.page.section = 'amea';
                dataLayer.analytics.page.name = 'amea:mysonyloyalty:registerproduct';
                dataLayer.analytics.page.template = 'mysonyloyalty:registerproduct';
                dataLayer.analytics.page.template_revision = 'mysonyloyalty:registerproduct';
            }
            else if (pageFromURL.indexOf('contact') >= 0 && mySonyURL == "signup") {
                dataLayer.analytics.page.section = 'amea';
                dataLayer.analytics.page.name = 'amea:mysonyloyalty:signup';
                dataLayer.analytics.page.template = 'mysonyloyalty:signup';
                dataLayer.analytics.page.template_revision = 'mysonyloyalty:signup';
            }
            else if (pageFromURL.indexOf('contact') >= 0 && mySonyURL.indexOf('successsignup') >= 0 ) {
                dataLayer.analytics.page.section = 'amea';
                dataLayer.analytics.page.name = 'amea:mysonyloyalty:signup:success';
                dataLayer.analytics.page.template = 'mysonyloyalty:signup:success';
                dataLayer.analytics.page.template_revision = 'mysonyloyalty:signup:success';
            }

            else if (pageFromURL.indexOf('loyalty') >= 0 && mySonyURL == "dashboard.html") {
                dataLayer.analytics.page.section = 'amea';
                dataLayer.analytics.page.name = 'amea:mysonyloyalty:dashboard';
                dataLayer.analytics.page.template = 'mysonyloyalty:dashboard';
                dataLayer.analytics.page.template_revision = 'mysonyloyalty:dashboard';
            }
            else if (pageFromURL.indexOf('loyalty') >= 0 && mySonyURL == "myprofile.html") {
                dataLayer.analytics.page.section = 'amea';
                dataLayer.analytics.page.name = 'amea:mysonyloyalty:myprofile';
                dataLayer.analytics.page.template = 'mysonyloyalty:myprofile';
                dataLayer.analytics.page.template_revision = 'mysonyloyalty:myprofile';
            }
            else if (pageFromURL.indexOf('profile') >= 0 && mySonyURL == "accountsetting") {
                dataLayer.analytics.page.section = 'amea';
                dataLayer.analytics.page.name = 'amea:mysonyloyalty:myprofile:accountsetting';
                dataLayer.analytics.page.template = 'mysonyloyalty:myprofile:accountsetting';
                dataLayer.analytics.page.template_revision = 'mysonyloyalty:myprofile:accountsetting';
            }
            else if (pageFromURL.indexOf('profile') >= 0 && mySonyURL.indexOf('successaccountsetting') >= 0) {
                dataLayer.analytics.page.section = 'amea';
                dataLayer.analytics.page.name = 'amea:mysonyloyalty:accountsetting:success';
                dataLayer.analytics.page.template = 'mysonyloyalty:accountsetting:success';
                dataLayer.analytics.page.template_revision = 'mysonyloyalty:accountsetting:success';
            }
            else if (pageFromURL.indexOf('profile') >= 0 && mySonyURL == "terminate") {
                dataLayer.analytics.page.section = 'amea';
                dataLayer.analytics.page.name = 'amea:mysonyloyalty:myprofile:accountsetting:terminate';
                dataLayer.analytics.page.template = 'mysonyloyalty:myprofile:accountsetting:terminate';
                dataLayer.analytics.page.template_revision = 'mysonyloyalty:myprofile:accountsetting:terminate';
            }
            else if (pageFromURL.indexOf('loyalty') >= 0 && mySonyURL == "myrewards.html") {
                dataLayer.analytics.page.section = 'amea';
                dataLayer.analytics.page.name = 'amea:mysonyloyalty:myrewards';
                dataLayer.analytics.page.template = 'mysonyloyalty:myrewards';
                dataLayer.analytics.page.template_revision = 'mysonyloyalty:myrewards';
            }
            else if (pageFromURL.indexOf('loyalty') >= 0 && mySonyURL == "pointhistorypage.html") {
                dataLayer.analytics.page.section = 'amea';
                dataLayer.analytics.page.name = 'amea:mysonyloyalty:myrewards:pointhistory';
                dataLayer.analytics.page.template = 'mysonyloyalty:myrewards:pointhistory';
                dataLayer.analytics.page.template_revision = 'mysonyloyalty:myrewards:pointhistory';
            }
            else if (pageFromURL.indexOf('product') >= 0 && mySonyURL == "registered") {
                dataLayer.analytics.page.section = 'amea';
                dataLayer.analytics.page.name = 'amea:mysonyloyalty:myproduct:registered';
                dataLayer.analytics.page.template = 'mysonyloyalty:myproduct:registered';
                dataLayer.analytics.page.template_revision = 'mysonyloyalty:myproduct:registered';
            }
            else if (pageFromURL.indexOf('product') >= 0 && mySonyURL == "register") {
                dataLayer.analytics.page.section = 'amea';
                dataLayer.analytics.page.name = 'amea:mysonyloyalty:myproduct:register';
                dataLayer.analytics.page.template = 'mysonyloyalty:myproduct:register';
                dataLayer.analytics.page.template_revision = 'mysonyloyalty:myproduct:register';
            }
            else if (pageFromURL.indexOf('loyalty') >= 0 && mySonyURL == "rewardscatalog.html") {
                dataLayer.analytics.page.section = 'amea';
                dataLayer.analytics.page.name = 'amea:mysonyloyalty:rewardscatalog';
                dataLayer.analytics.page.template = 'mysonyloyalty:rewardscatalog';
                dataLayer.analytics.page.template_revision = 'mysonyloyalty:rewardscatalog';
            }
            return dataLayer;
        };
    };
}
/*]]>*/

